export const lightTheme = {
  color: {
    bg: {
      canvas: "var(--c6-color-bg-canvas)",
      surface: "var(--c6-color-bg-surface)",
      surfaceSunken: "var(--c6-color-bg-surface-sunken)",
      surfaceRaised: "var(--c6-color-bg-surface-raised)",
      surfaceRaisedHigh: "var(--c6-color-bg-surface-raised-high)",
      surfaceOverlay: "var(--c6-color-bg-surface-overlay)",
      inverse: "var(--c6-color-bg-inverse)",
      muted: "var(--c6-color-bg-muted)",
      selected: "var(--c6-color-bg-selected)",
      selectedHover: "var(--c6-color-bg-selected-hover)",
      selectedActive: "var(--c6-color-bg-selected-active)",
      attention: "var(--c6-color-bg-attention)",
      attentionHover: "var(--c6-color-bg-attention-hover)",
      attentionActive: "var(--c6-color-bg-attention-active)",
      dangerSurface: "var(--c6-color-bg-danger-surface)",
      control: {
        primary: "var(--c6-color-bg-control-primary)",
        primaryHover: "var(--c6-color-bg-control-primary-hover)",
        primaryActive: "var(--c6-color-bg-control-primary-active)",
        primarySubtle: "var(--c6-color-bg-control-primary-subtle)",
        primarySubtleHover: "var(--c6-color-bg-control-primary-subtle-hover)",
        secondary: "var(--c6-color-bg-control-secondary)",
        secondaryHover: "var(--c6-color-bg-control-secondary-hover)",
        secondaryActive: "var(--c6-color-bg-control-secondary-active)",
        neutral: "var(--c6-color-bg-control-neutral)",
        neutralHover: "var(--c6-color-bg-control-neutral-hover)",
        neutralActive: "var(--c6-color-bg-control-neutral-active)",
        trackingPlay: "var(--c6-color-bg-control-tracking-play)",
        danger: "var(--c6-color-bg-control-danger)",
        dangerHover: "var(--c6-color-bg-control-danger-hover)",
        dangerActive: "var(--c6-color-bg-control-danger-active)",
        warning: "var(--c6-color-bg-control-warning)",
        warningHover: "var(--c6-color-bg-control-warning-hover)",
        warningActive: "var(--c6-color-bg-control-warning-active)",
        disabled: "var(--c6-color-bg-control-disabled)",
        disabledSunken: "var(--c6-color-bg-control-disabled-sunken)",
      },
    },
    text: {
      muted: "var(--c6-color-text-muted)",
      subtle: "var(--c6-color-text-subtle)",
      default: "var(--c6-color-text-default)",
      strong: "var(--c6-color-text-strong)",
      disabled: "var(--c6-color-text-disabled)",
      accent: "var(--c6-color-text-accent)",
      warning: "var(--c6-color-text-warning)",
      danger: "var(--c6-color-text-danger)",
      inverse: "var(--c6-color-text-inverse)",
      onControl: "var(--c6-color-text-on-control)",
      onWarningControl: "var(--c6-color-text-on-warning-control)",
      onDangerControl: "var(--c6-color-text-on-danger-control)",
      onDangerSurface: "var(--c6-color-text-on-danger-surface)",
      onStatus: "var(--c6-color-text-on-status)",
    },
    border: {
      divider: "var(--c6-color-border-divider)",
      subtle: "var(--c6-color-border-subtle)",
      default: "var(--c6-color-border-default)",
      strong: "var(--c6-color-border-strong)",
      emphasis: "var(--c6-color-border-emphasis)",
      focus: "var(--c6-color-border-focus)",
      selected: "var(--c6-color-border-selected)",
      selectedHover: "var(--c6-color-border-selected-hover)",
      selectedActive: "var(--c6-color-border-selected-active)",
      danger: "var(--c6-color-border-danger)",
      dangerSurface: "var(--c6-color-border-danger-surface)",
      disabled: "var(--c6-color-border-disabled)",
    },
    slider: {
      track: {
        enabled: "var(--c6-color-slider-track-enabled)",
        disabled: "var(--c6-color-slider-track-disabled)",
      },
      activeTrack: {
        enabled: "var(--c6-color-slider-active-track-enabled)",
        hover: "var(--c6-color-slider-active-track-hover)",
        focused: "var(--c6-color-slider-active-track-focused)",
        pressed: "var(--c6-color-slider-active-track-pressed)",
        disabled: "var(--c6-color-slider-active-track-disabled)",
      },
      thumb: {
        enabled: "var(--c6-color-slider-thumb-enabled)",
        hover: "var(--c6-color-slider-thumb-hover)",
        focused: "var(--c6-color-slider-thumb-focused)",
        pressed: "var(--c6-color-slider-thumb-pressed)",
        disabled: "var(--c6-color-slider-thumb-disabled)",
      },
      tick: {
        enabled: "var(--c6-color-slider-tick-enabled)",
        active: "var(--c6-color-slider-tick-active)",
        disabled: "var(--c6-color-slider-tick-disabled)",
      },
      valueLabel: {
        bg: "var(--c6-color-slider-value-label-bg)",
        text: "var(--c6-color-slider-value-label-text)",
      },
    },
    switch: {
      track: {
        enabled: "var(--c6-color-switch-track-enabled)",
        hover: "var(--c6-color-switch-track-hover)",
        pressed: "var(--c6-color-switch-track-pressed)",
        disabled: "var(--c6-color-switch-track-disabled)",
      },
      activeTrack: {
        enabled: "var(--c6-color-switch-active-track-enabled)",
        hover: "var(--c6-color-switch-active-track-hover)",
        pressed: "var(--c6-color-switch-active-track-pressed)",
        disabled: "var(--c6-color-switch-active-track-disabled)",
      },
      border: {
        enabled: "var(--c6-color-switch-border-enabled)",
        disabled: "var(--c6-color-switch-border-disabled)",
      },
      thumb: {
        enabled: "var(--c6-color-switch-thumb-enabled)",
        hover: "var(--c6-color-switch-thumb-hover)",
        pressed: "var(--c6-color-switch-thumb-pressed)",
        disabled: "var(--c6-color-switch-thumb-disabled)",
      },
      activeThumb: {
        enabled: "var(--c6-color-switch-active-thumb-enabled)",
        hover: "var(--c6-color-switch-active-thumb-hover)",
        pressed: "var(--c6-color-switch-active-thumb-pressed)",
      },
    },
    scrim: {
      default: "var(--c6-color-scrim-default)",
      overlay: "var(--c6-color-scrim-overlay)",
    },
    brand: {
      primary: "var(--c6-color-brand-primary)",
    },
    // dataViz — 카테고리(데이터 구분) hue 7종. 의미는 소비 앱이 배정한다(tokens.ts 주석 참조).
    dataViz: {
      red: "var(--c6-color-data-viz-red)",
      orange: "var(--c6-color-data-viz-orange)",
      amber: "var(--c6-color-data-viz-amber)",
      green: "var(--c6-color-data-viz-green)",
      blue: "var(--c6-color-data-viz-blue)",
      violet: "var(--c6-color-data-viz-violet)",
      gray: "var(--c6-color-data-viz-gray)",
    },
    status: {
      success: "var(--c6-color-status-success)",
      successSelected: "var(--c6-color-status-success-selected)",
      successSelectedHover: "var(--c6-color-status-success-selected-hover)",
      successSelectedActive: "var(--c6-color-status-success-selected-active)",
      running: "var(--c6-color-status-running)",
      runningSelected: "var(--c6-color-status-running-selected)",
      runningSelectedHover: "var(--c6-color-status-running-selected-hover)",
      runningSelectedActive: "var(--c6-color-status-running-selected-active)",
      paused: "var(--c6-color-status-paused)",
      pausedSelected: "var(--c6-color-status-paused-selected)",
      pausedSelectedHover: "var(--c6-color-status-paused-selected-hover)",
      pausedSelectedActive: "var(--c6-color-status-paused-selected-active)",
      error: "var(--c6-color-status-error)",
      errorSelected: "var(--c6-color-status-error-selected)",
      errorSelectedHover: "var(--c6-color-status-error-selected-hover)",
      errorSelectedActive: "var(--c6-color-status-error-selected-active)",
      warning: "var(--c6-color-status-warning)",
      warningSelected: "var(--c6-color-status-warning-selected)",
      warningSelectedHover: "var(--c6-color-status-warning-selected-hover)",
      warningSelectedActive: "var(--c6-color-status-warning-selected-active)",
      info: "var(--c6-color-status-info)",
      infoSelected: "var(--c6-color-status-info-selected)",
      infoSelectedHover: "var(--c6-color-status-info-selected-hover)",
      infoSelectedActive: "var(--c6-color-status-info-selected-active)",
      muted: "var(--c6-color-status-muted)",
      mutedSelected: "var(--c6-color-status-muted-selected)",
      mutedSelectedHover: "var(--c6-color-status-muted-selected-hover)",
      mutedSelectedActive: "var(--c6-color-status-muted-selected-active)",
      completed: "var(--c6-color-status-completed)",
      completedSelected: "var(--c6-color-status-completed-selected)",
      completedSelectedHover: "var(--c6-color-status-completed-selected-hover)",
      completedSelectedActive: "var(--c6-color-status-completed-selected-active)",
      ready: "var(--c6-color-status-ready)",
      readySelected: "var(--c6-color-status-ready-selected)",
      readySelectedHover: "var(--c6-color-status-ready-selected-hover)",
      readySelectedActive: "var(--c6-color-status-ready-selected-active)",
      recording: "var(--c6-color-status-recording)",
      recordingSelected: "var(--c6-color-status-recording-selected)",
      recordingSelectedHover: "var(--c6-color-status-recording-selected-hover)",
      recordingSelectedActive: "var(--c6-color-status-recording-selected-active)",
      cancelling: "var(--c6-color-status-cancelling)",
      cancellingSelected: "var(--c6-color-status-cancelling-selected)",
      cancellingSelectedHover: "var(--c6-color-status-cancelling-selected-hover)",
      cancellingSelectedActive: "var(--c6-color-status-cancelling-selected-active)",
      attention: "var(--c6-color-status-attention)",
      attentionSelected: "var(--c6-color-status-attention-selected)",
      attentionSelectedHover: "var(--c6-color-status-attention-selected-hover)",
      attentionSelectedActive: "var(--c6-color-status-attention-selected-active)",
      exhausted: "var(--c6-color-status-exhausted)",
      exhaustedSelected: "var(--c6-color-status-exhausted-selected)",
      exhaustedSelectedHover: "var(--c6-color-status-exhausted-selected-hover)",
      exhaustedSelectedActive: "var(--c6-color-status-exhausted-selected-active)",
      checking: "var(--c6-color-status-checking)",
      checkingSelected: "var(--c6-color-status-checking-selected)",
      checkingSelectedHover: "var(--c6-color-status-checking-selected-hover)",
      checkingSelectedActive: "var(--c6-color-status-checking-selected-active)",
      device: {
        healthy: "var(--c6-color-status-device-healthy)",
        healthySelected: "var(--c6-color-status-device-healthy-selected)",
        healthySelectedHover: "var(--c6-color-status-device-healthy-selected-hover)",
        healthySelectedActive: "var(--c6-color-status-device-healthy-selected-active)",
        degraded: "var(--c6-color-status-device-degraded)",
        degradedSelected: "var(--c6-color-status-device-degraded-selected)",
        degradedSelectedHover: "var(--c6-color-status-device-degraded-selected-hover)",
        degradedSelectedActive: "var(--c6-color-status-device-degraded-selected-active)",
        error: "var(--c6-color-status-device-error)",
        errorSelected: "var(--c6-color-status-device-error-selected)",
        errorSelectedHover: "var(--c6-color-status-device-error-selected-hover)",
        errorSelectedActive: "var(--c6-color-status-device-error-selected-active)",
        offline: "var(--c6-color-status-device-offline)",
        offlineSelected: "var(--c6-color-status-device-offline-selected)",
        offlineSelectedHover: "var(--c6-color-status-device-offline-selected-hover)",
        offlineSelectedActive: "var(--c6-color-status-device-offline-selected-active)",
        checking: "var(--c6-color-status-device-checking)",
        checkingSelected: "var(--c6-color-status-device-checking-selected)",
        checkingSelectedHover: "var(--c6-color-status-device-checking-selected-hover)",
        checkingSelectedActive: "var(--c6-color-status-device-checking-selected-active)",
      },
      job: {
        pending: "var(--c6-color-status-job-pending)",
        pendingSelected: "var(--c6-color-status-job-pending-selected)",
        pendingSelectedHover: "var(--c6-color-status-job-pending-selected-hover)",
        pendingSelectedActive: "var(--c6-color-status-job-pending-selected-active)",
        running: "var(--c6-color-status-job-running)",
        runningSelected: "var(--c6-color-status-job-running-selected)",
        runningSelectedHover: "var(--c6-color-status-job-running-selected-hover)",
        runningSelectedActive: "var(--c6-color-status-job-running-selected-active)",
        cancelling: "var(--c6-color-status-job-cancelling)",
        cancellingSelected: "var(--c6-color-status-job-cancelling-selected)",
        cancellingSelectedHover: "var(--c6-color-status-job-cancelling-selected-hover)",
        cancellingSelectedActive: "var(--c6-color-status-job-cancelling-selected-active)",
        cancelled: "var(--c6-color-status-job-cancelled)",
        cancelledSelected: "var(--c6-color-status-job-cancelled-selected)",
        cancelledSelectedHover: "var(--c6-color-status-job-cancelled-selected-hover)",
        cancelledSelectedActive: "var(--c6-color-status-job-cancelled-selected-active)",
        failed: "var(--c6-color-status-job-failed)",
        failedSelected: "var(--c6-color-status-job-failed-selected)",
        failedSelectedHover: "var(--c6-color-status-job-failed-selected-hover)",
        failedSelectedActive: "var(--c6-color-status-job-failed-selected-active)",
        succeeded: "var(--c6-color-status-job-succeeded)",
        succeededSelected: "var(--c6-color-status-job-succeeded-selected)",
        succeededSelectedHover: "var(--c6-color-status-job-succeeded-selected-hover)",
        succeededSelectedActive: "var(--c6-color-status-job-succeeded-selected-active)",
        actionRequired: "var(--c6-color-status-job-action-required)",
        actionRequiredSelected: "var(--c6-color-status-job-action-required-selected)",
        actionRequiredSelectedHover: "var(--c6-color-status-job-action-required-selected-hover)",
        actionRequiredSelectedActive: "var(--c6-color-status-job-action-required-selected-active)",
      },
      dataCapture: {
        off: "var(--c6-color-status-data-capture-off)",
        offSelected: "var(--c6-color-status-data-capture-off-selected)",
        offSelectedHover: "var(--c6-color-status-data-capture-off-selected-hover)",
        offSelectedActive: "var(--c6-color-status-data-capture-off-selected-active)",
        loading: "var(--c6-color-status-data-capture-loading)",
        loadingSelected: "var(--c6-color-status-data-capture-loading-selected)",
        loadingSelectedHover: "var(--c6-color-status-data-capture-loading-selected-hover)",
        loadingSelectedActive: "var(--c6-color-status-data-capture-loading-selected-active)",
        loaded: "var(--c6-color-status-data-capture-loaded)",
        loadedSelected: "var(--c6-color-status-data-capture-loaded-selected)",
        loadedSelectedHover: "var(--c6-color-status-data-capture-loaded-selected-hover)",
        loadedSelectedActive: "var(--c6-color-status-data-capture-loaded-selected-active)",
        running: "var(--c6-color-status-data-capture-running)",
        runningSelected: "var(--c6-color-status-data-capture-running-selected)",
        runningSelectedHover: "var(--c6-color-status-data-capture-running-selected-hover)",
        runningSelectedActive: "var(--c6-color-status-data-capture-running-selected-active)",
        paused: "var(--c6-color-status-data-capture-paused)",
        pausedSelected: "var(--c6-color-status-data-capture-paused-selected)",
        pausedSelectedHover: "var(--c6-color-status-data-capture-paused-selected-hover)",
        pausedSelectedActive: "var(--c6-color-status-data-capture-paused-selected-active)",
        completed: "var(--c6-color-status-data-capture-completed)",
        completedSelected: "var(--c6-color-status-data-capture-completed-selected)",
        completedSelectedHover: "var(--c6-color-status-data-capture-completed-selected-hover)",
        completedSelectedActive: "var(--c6-color-status-data-capture-completed-selected-active)",
        error: "var(--c6-color-status-data-capture-error)",
        errorSelected: "var(--c6-color-status-data-capture-error-selected)",
        errorSelectedHover: "var(--c6-color-status-data-capture-error-selected-hover)",
        errorSelectedActive: "var(--c6-color-status-data-capture-error-selected-active)",
        idle: "var(--c6-color-status-data-capture-idle)",
        idleSelected: "var(--c6-color-status-data-capture-idle-selected)",
        idleSelectedHover: "var(--c6-color-status-data-capture-idle-selected-hover)",
        idleSelectedActive: "var(--c6-color-status-data-capture-idle-selected-active)",
        recording: "var(--c6-color-status-data-capture-recording)",
        recordingSelected: "var(--c6-color-status-data-capture-recording-selected)",
        recordingSelectedHover: "var(--c6-color-status-data-capture-recording-selected-hover)",
        recordingSelectedActive: "var(--c6-color-status-data-capture-recording-selected-active)",
        recovery: "var(--c6-color-status-data-capture-recovery)",
        recoverySelected: "var(--c6-color-status-data-capture-recovery-selected)",
        recoverySelectedHover: "var(--c6-color-status-data-capture-recovery-selected-hover)",
        recoverySelectedActive: "var(--c6-color-status-data-capture-recovery-selected-active)",
        done: "var(--c6-color-status-data-capture-done)",
        doneSelected: "var(--c6-color-status-data-capture-done-selected)",
        doneSelectedHover: "var(--c6-color-status-data-capture-done-selected-hover)",
        doneSelectedActive: "var(--c6-color-status-data-capture-done-selected-active)",
        committing: "var(--c6-color-status-data-capture-committing)",
        committingSelected: "var(--c6-color-status-data-capture-committing-selected)",
        committingSelectedHover: "var(--c6-color-status-data-capture-committing-selected-hover)",
        committingSelectedActive: "var(--c6-color-status-data-capture-committing-selected-active)",
        checking: "var(--c6-color-status-data-capture-checking)",
        checkingSelected: "var(--c6-color-status-data-capture-checking-selected)",
        checkingSelectedHover: "var(--c6-color-status-data-capture-checking-selected-hover)",
        checkingSelectedActive: "var(--c6-color-status-data-capture-checking-selected-active)",
      },
      inference: {
        loading: "var(--c6-color-status-inference-loading)",
        loadingSelected: "var(--c6-color-status-inference-loading-selected)",
        loadingSelectedHover: "var(--c6-color-status-inference-loading-selected-hover)",
        loadingSelectedActive: "var(--c6-color-status-inference-loading-selected-active)",
        loaded: "var(--c6-color-status-inference-loaded)",
        loadedSelected: "var(--c6-color-status-inference-loaded-selected)",
        loadedSelectedHover: "var(--c6-color-status-inference-loaded-selected-hover)",
        loadedSelectedActive: "var(--c6-color-status-inference-loaded-selected-active)",
        running: "var(--c6-color-status-inference-running)",
        runningSelected: "var(--c6-color-status-inference-running-selected)",
        runningSelectedHover: "var(--c6-color-status-inference-running-selected-hover)",
        runningSelectedActive: "var(--c6-color-status-inference-running-selected-active)",
        paused: "var(--c6-color-status-inference-paused)",
        pausedSelected: "var(--c6-color-status-inference-paused-selected)",
        pausedSelectedHover: "var(--c6-color-status-inference-paused-selected-hover)",
        pausedSelectedActive: "var(--c6-color-status-inference-paused-selected-active)",
        stopping: "var(--c6-color-status-inference-stopping)",
        stoppingSelected: "var(--c6-color-status-inference-stopping-selected)",
        stoppingSelectedHover: "var(--c6-color-status-inference-stopping-selected-hover)",
        stoppingSelectedActive: "var(--c6-color-status-inference-stopping-selected-active)",
        completed: "var(--c6-color-status-inference-completed)",
        completedSelected: "var(--c6-color-status-inference-completed-selected)",
        completedSelectedHover: "var(--c6-color-status-inference-completed-selected-hover)",
        completedSelectedActive: "var(--c6-color-status-inference-completed-selected-active)",
        off: "var(--c6-color-status-inference-off)",
        offSelected: "var(--c6-color-status-inference-off-selected)",
        offSelectedHover: "var(--c6-color-status-inference-off-selected-hover)",
        offSelectedActive: "var(--c6-color-status-inference-off-selected-active)",
        error: "var(--c6-color-status-inference-error)",
        errorSelected: "var(--c6-color-status-inference-error-selected)",
        errorSelectedHover: "var(--c6-color-status-inference-error-selected-hover)",
        errorSelectedActive: "var(--c6-color-status-inference-error-selected-active)",
      },
      capacity: {
        ample: "var(--c6-color-status-capacity-ample)",
        ampleSelected: "var(--c6-color-status-capacity-ample-selected)",
        ampleSelectedHover: "var(--c6-color-status-capacity-ample-selected-hover)",
        ampleSelectedActive: "var(--c6-color-status-capacity-ample-selected-active)",
        tight: "var(--c6-color-status-capacity-tight)",
        tightSelected: "var(--c6-color-status-capacity-tight-selected)",
        tightSelectedHover: "var(--c6-color-status-capacity-tight-selected-hover)",
        tightSelectedActive: "var(--c6-color-status-capacity-tight-selected-active)",
        scarce: "var(--c6-color-status-capacity-scarce)",
        scarceSelected: "var(--c6-color-status-capacity-scarce-selected)",
        scarceSelectedHover: "var(--c6-color-status-capacity-scarce-selected-hover)",
        scarceSelectedActive: "var(--c6-color-status-capacity-scarce-selected-active)",
        exhausted: "var(--c6-color-status-capacity-exhausted)",
        exhaustedSelected: "var(--c6-color-status-capacity-exhausted-selected)",
        exhaustedSelectedHover: "var(--c6-color-status-capacity-exhausted-selected-hover)",
        exhaustedSelectedActive: "var(--c6-color-status-capacity-exhausted-selected-active)",
        unknown: "var(--c6-color-status-capacity-unknown)",
        unknownSelected: "var(--c6-color-status-capacity-unknown-selected)",
        unknownSelectedHover: "var(--c6-color-status-capacity-unknown-selected-hover)",
        unknownSelectedActive: "var(--c6-color-status-capacity-unknown-selected-active)",
      },
    },
  },
  elevation: {
    hairline: "var(--c6-elevation-hairline)",
    shadow: {
      level: {
        1: "var(--c6-elevation-shadow-level-1)",
        2: "var(--c6-elevation-shadow-level-2)",
        3: "var(--c6-elevation-shadow-level-3)",
        4: "var(--c6-elevation-shadow-level-4)",
      },
      overlay: "var(--c6-elevation-shadow-overlay)",
      modal: "var(--c6-elevation-shadow-modal)",
    },
  },
  shape: {
    radius: {
      control: "var(--c6-shape-radius-control)",
      surface: "var(--c6-shape-radius-surface)",
      tooltip: "var(--c6-shape-radius-tooltip)",
    },
  },
  typography: {
    family: {
      body: "var(--c6-typography-family-body)",
      mono: "var(--c6-typography-family-mono)",
    },
    weight: {
      regular: "var(--c6-typography-weight-regular)",
      medium: "var(--c6-typography-weight-medium)",
      semibold: "var(--c6-typography-weight-semibold)",
      bold: "var(--c6-typography-weight-bold)",
      extrabold: "var(--c6-typography-weight-extrabold)",
      action: "var(--c6-typography-weight-action)",
    },
    size: {
      caption: "var(--c6-typography-size-caption)",
      body: "var(--c6-typography-size-body)",
      title: "var(--c6-typography-size-title)",
      head: "var(--c6-typography-size-head)",
      headLarge: "var(--c6-typography-size-head-large)",
      headXLarge: "var(--c6-typography-size-head-x-large)",
    },
    lineHeight: {
      tight: "var(--c6-typography-line-height-tight)",
      snug: "var(--c6-typography-line-height-snug)",
      normal: "var(--c6-typography-line-height-normal)",
    },
  },
} as const;

export type Theme = typeof lightTheme;
